import { render, staticRenderFns } from "./SearchPatient.vue?vue&type=template&id=5cd2b1da&scoped=true"
import script from "./SearchPatient.vue?vue&type=script&lang=js"
export * from "./SearchPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd2b1da",
  null
  
)

export default component.exports